import { render } from "./TeamTypeTile.vue?vue&type=template&id=0a5ff5c3"
import script from "./TeamTypeTile.vue?vue&type=script&lang=js"
export * from "./TeamTypeTile.vue?vue&type=script&lang=js"

import "./TeamTypeTile.vue?vue&type=style&index=0&id=0a5ff5c3&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__